// extracted by mini-css-extract-plugin
export default {"root":"B4kpC","content":"VpVn0"};